import classNames from 'classnames';
import React from 'react';

import { uiTypographyClassNames } from './class-names';
import { UiTypographyProps } from './types';
import './Typography.scss';

export const UiTypography = React.forwardRef<
  HTMLElement,
  React.PropsWithChildren<UiTypographyProps>
>(function UiTypography(
  {
    align,
    color = 'black',
    variant = 'body-medium',
    children,
    className,
    component = 'p',
    transform,
    decoration,
    fontStyle,
    onClick,
    TEST_ID,
    style,
    htmlFor,
  },
  ref,
) {
  const classes = classNames(
    'ui-typography',
    uiTypographyClassNames.color(color),
    uiTypographyClassNames.variant(variant),
    transform && uiTypographyClassNames.transform(transform),
    align && uiTypographyClassNames.align(align),
    decoration && uiTypographyClassNames.decoration(decoration),
    fontStyle && uiTypographyClassNames.fontStyle(fontStyle),
    className,
  );

  const Component = component as React.ElementType;

  return (
    <Component
      ref={ref}
      onClick={onClick}
      className={classes}
      data-testid={TEST_ID}
      style={style}
      htmlFor={htmlFor}
    >
      {children}
    </Component>
  );
});
